import React from 'react';

const DeliveryInfo = () => {
  return (
    <section className="py-32 px-6 bg-background border-t border-border/40">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-serif font-normal text-primary mb-6 tracking-wide">
            Házhozszállítási információk
          </h2>
          <div className="h-px w-12 bg-accent mx-auto"></div>
        </div>

        <div className="bg-secondary/10 border border-border p-10 md:p-16">
          <ul className="space-y-10 text-foreground font-light leading-relaxed">
            
            <li className="flex flex-col md:flex-row gap-2 md:gap-8">
              <span className="font-serif font-medium uppercase tracking-widest text-sm md:w-1/3 flex-shrink-0 pt-1 text-primary">
                Rendelésfelvétel
              </span>
              <span className="text-muted-foreground md:w-2/3">
                Reggel 8-tól 15 óráig veszünk fel rendeléseket.
              </span>
            </li>
            
            <li className="flex flex-col md:flex-row gap-2 md:gap-8">
              <span className="font-serif font-medium uppercase tracking-widest text-sm md:w-1/3 flex-shrink-0 pt-1 text-primary">
                Szállítási idősávok
              </span>
              <div className="text-muted-foreground md:w-2/3 space-y-4">
                <div className="flex items-start gap-4">
                  <span className="text-accent mt-2 h-1.5 w-1.5 flex-shrink-0 bg-accent rounded-none rotate-45"></span>
                  <span>A 10:15-ig leadott rendelések 11:00 és 13:30 között kerülnek kiszállításra.</span>
                </div>
                <div className="flex items-start gap-4">
                  <span className="text-accent mt-2 h-1.5 w-1.5 flex-shrink-0 bg-accent rounded-none rotate-45"></span>
                  <span>A 10:15 után beérkezett megrendelések 12:30-tól folyamatosan kerülnek kiszállításra.</span>
                </div>
              </div>
            </li>

            <li className="flex flex-col md:flex-row gap-2 md:gap-8">
              <span className="font-serif font-medium uppercase tracking-widest text-sm md:w-1/3 flex-shrink-0 pt-1 text-primary">
                Kiszállítási díj
              </span>
              <span className="text-muted-foreground md:w-2/3">
                250 Ft / rendelés (10.000 Ft feletti rendelés esetén ingyenes).
              </span>
            </li>

            <li className="flex flex-col md:flex-row gap-2 md:gap-8">
              <span className="font-serif font-medium uppercase tracking-widest text-sm md:w-1/3 flex-shrink-0 pt-1 text-primary">
                Kiszállítási területek
              </span>
              <span className="text-muted-foreground md:w-2/3 leading-loose">
                Belváros, Bodótető, Győrikapu, Diósgyőr, Avas, Hejőcsaba, Martinkertváros, Szentpéteri kapu, Zsarnai telep.
              </span>
            </li>

          </ul>
        </div>
      </div>
    </section>
  );
};

export default DeliveryInfo;
